import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useStore } from "../stores";

export const Results = () => {
  const searchString = useStore((state) => state.searchString);
  const setSearchString = useStore((state) => state.setSearchString);
  const search = useStore((state) => state.search);
  const results = useStore((state) => state.results);
  const resetResults = useStore((state) => state.resetResults);
  const setSelectedUseplaceId = useStore(
    (state) => state.setSelectedUseplaceId
  );
  // const resetSelectedUseplace = useStore(
  //   (state) => state.resetSelectedUseplace
  // );

  useEffect(() => {
    if (searchString.length > 3) {
      search(searchString);
    } else {
      resetResults();
    }
  }, [searchString]);

  const highLightText = (text: string, white: boolean = false) => {
    if (!text) return "";
    const regex = new RegExp(searchString, "gi");
    return text.replace(
      regex,
      (match) =>
        `<span class="${
          white ? "text-white" : "text-black"
        } font-semibold">${match}</span>`
    );
  };

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleUserKeyPress = (event: KeyboardEvent) => {
    if (results && results.length < 1 && event.key === "Enter") {
      window.document.location.href = "/order/okand";
    }
    if (!results || results.length < 1) return;
    switch (event.key) {
      case "ArrowDown":
        if (selectedIndex < results.length - 1) {
          setSelectedIndex(selectedIndex + 1);
        }
        break;
      case "ArrowUp":
        if (selectedIndex > 0 && selectedIndex < results.length - 1) {
          setSelectedIndex(selectedIndex - 1);
        }
        break;

      case "Tab":
        event.preventDefault();
        setSearchString(results[selectedIndex].fulladdress);
        break;

      case "Enter":
        setSelectedUseplaceId(results[selectedIndex].id);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleUserKeyPress);
    return () => {
      window.removeEventListener("keydown", handleUserKeyPress);
    };
  }, [handleUserKeyPress]);

  useEffect(() => {
    setSelectedIndex(0);
  }, [results]);

  useEffect(() => {
    if (!results || results.length < 1) return;
    const ul = document.querySelector(".result-ul") as HTMLDivElement;
    const li = ul.querySelector(
      `li.result-li-${results[selectedIndex].id}`
    ) as HTMLLIElement;
    if (!li) return;
    if (li.offsetTop > ul.offsetHeight) {
      ul.scrollTo(0, li.offsetTop - ul.offsetHeight + li.offsetHeight);
    }
  }, [selectedIndex]);

  if (!results) return null;

  return (
    <motion.div
      className="absolute w-full  border border-dotted  shadow-xl z-10 max-h-96 overflow-y-scroll rounded-sm result-ul bg-white"
      layout
      layoutId="resultWrapper"
    >
      <motion.ul
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        className=""
      >
        {results.length > 0 ? (
          results.map((result, idx) => (
            <li
              tabIndex={-1}
              key={`result-${result.id}`}
              className={`py-2 px-4 border border-gray-300 cursor-pointer flex justify-between text-slate-500 ${
                idx === selectedIndex && "bg-secondary-500 text-gray-300"
              } result-li-${result.id}`}
              onClick={() => setSelectedUseplaceId(result.id)}
              data-address={result.fulladdress}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: highLightText(
                    result.fulladdress,
                    idx === selectedIndex
                  ),
                }}
              />
              <div
                dangerouslySetInnerHTML={{
                  __html: highLightText(result.propertyid),
                }}
              />
            </li>
          ))
        ) : (
          <a
            href="/order/okand"
            className="py-4 px-4 border border-gray-300 cursor-pointer flex justify-between bg-accent-500 text-white"
          >
            Vi kunde inte matcha din sökning, kontrollera stavningen eller
            skicka en förfrågan till oss.
          </a>
        )}
      </motion.ul>
    </motion.div>
  );
};
